import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchAchievements = (): Promise<AxiosResponse> =>
  get('/achievements/achievements', {
    include: 'imageMedia,userAchievement,userAchievementsCount',
  })
